module.exports = __webpack_public_path__ + "NEDA-ee826f226e349c6c8d23490e65e59619.png";